module.exports = __webpack_public_path__ + "static/media/craft_keep_item_second.f7597833.mp3";